module.exports = __webpack_public_path__ + "images/avatars/female/3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/3.png
// module id = wpGM
// module chunks = 118